import { render, staticRenderFns } from "./TagManagement.vue?vue&type=template&id=06feb084&"
import script from "./TagManagement.vue?vue&type=script&lang=js&"
export * from "./TagManagement.vue?vue&type=script&lang=js&"
import style0 from "./TagManagement.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VCombobox } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VChip,
  VCombobox,
  VIcon,
  VListTile,
  VListTileAction,
  VListTileContent,
  VSnackbar,
  VSpacer,
  VTextField,
})
